import { render } from "./PerformanceMenagementEng.vue?vue&type=template&id=94987f22&scoped=true&lang=html"
import script from "./PerformanceMenagementEng.vue?vue&type=script&lang=js"
export * from "./PerformanceMenagementEng.vue?vue&type=script&lang=js"

import "./PerformanceMenagementEng.vue?vue&type=style&index=0&id=94987f22&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-94987f22"

export default script